<template>
  <a
    href="https://play.google.com/store/apps/details?id=co.orienteer.orienteerRun"
  >
    <img src="../assets/play-store.png" alt="Get the app on the play store" />
  </a>
</template>
